module.exports = __webpack_public_path__ + "static/004-77ff0c26e65760fa2e6b0a3750465912.png";